import { render, staticRenderFns } from "./RefSection.vue?vue&type=template&id=20a2ac1c&scoped=true&"
import script from "./RefSection.vue?vue&type=script&lang=js&"
export * from "./RefSection.vue?vue&type=script&lang=js&"
import style0 from "./RefSection.vue?vue&type=style&index=0&id=20a2ac1c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2ac1c",
  null
  
)

export default component.exports